import balloon from "../assets/Marcom design/Balloons.png";
import flower_yellow from "../assets/Marcom design/flower-yellow.png";
import oyster from "../assets/Marcom design/oyster.png";
import boat from "../assets/Marcom design/Boat.png";
import flower from "../assets/Marcom design/flower.png";
import pride_balloon from "../assets/Marcom design/Pride hotair balloon.png";
import cat_stretching from "../assets/Marcom design/Cat stretching.png";
import green_flower_1 from "../assets/Marcom design/green flower-1.png";
import rainbow from "../assets/Marcom design/Rainbow.png";
import coins from "../assets/Marcom design/Coins.png";
import green_flower from "../assets/Marcom design/green flower.png";
import tree from "../assets/Marcom design/tree.png";
import declutter from "../assets/Marcom design/Declutter.png";
import hand from "../assets/Marcom design/Hand.png";
import whale from "../assets/Marcom design/Whale.png";
import flower_1 from "../assets/Marcom design/Flower-1.png";
import letter from "../assets/Marcom design/letter.png";
import yellow_balloon from "../assets/Marcom design/Yellow hotair balloon.png";

const imageArray = [
  balloon,
  flower_yellow,
  oyster,
  boat,
  flower,
  pride_balloon,
  cat_stretching,
  green_flower_1,
  rainbow,
  coins,
  green_flower,
  tree,
  declutter,
  hand,
  whale,
  flower_1,
  letter,
  yellow_balloon,
];

export default function getRandomImage() {
  const randomIdx = Math.floor(Math.random() * imageArray.length);
  return imageArray[randomIdx];
}